/*
 * Interface strings, Thai.
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "เข้าสู่ระบบด้วยบัญชี AquaNetica ของคุณเพื่อดำเนินการต่อ",
  "landing.signIn": "เข้าสู่ระบบ",
  "landing.signUpFree": "สมัครใช้งานฟรี",
  "common.close": "ปิด",
  "common.cancel": "ยกเลิก",
  "profile.title": "ข้อมูลระบบ · {name}",
  "profile.subtitle": "Gia ใช้ข้อมูลนี้ปรับคำตอบทุกข้อในโปรเจกต์นี้ เว้นว่างได้หากไม่เกี่ยวข้อง",
  "profile.species": "ชนิดสัตว์น้ำ",
  "profile.speciesPlaceholder": "เช่น ปลาแซลมอนแอตแลนติก",
  "profile.systemType": "ประเภทระบบ",
  "profile.select": "เลือก…",
  "profile.sys.ras": "RAS (ระบบน้ำหมุนเวียน)",
  "profile.sys.flow": "ระบบน้ำไหลผ่าน",
  "profile.sys.pond": "บ่อดิน",
  "profile.sys.cage": "กระชัง",
  "profile.sys.hatchery": "โรงเพาะฟัก",
  "profile.sys.other": "อื่น ๆ",
  "profile.volume": "ปริมาตรน้ำรวม (L)",
  "profile.temp": "อุณหภูมิเป้าหมาย (°C)",
  "profile.lifeStage": "ช่วงการเลี้ยง",
  "profile.lifeStagePlaceholder": "ลูกปลา ปลารุ่น พ่อแม่พันธุ์",
  "profile.location": "สถานที่",
  "profile.locationPlaceholder": "เช่น สงขลา ประเทศไทย",
  "profile.notes": "หมายเหตุเพิ่มเติม",
  "profile.notesPlaceholder": "ข้อมูลอื่นเกี่ยวกับระบบนี้ที่ Gia ควรรู้",
  "profile.save": "บันทึกข้อมูลระบบ",
  "help.title": "เกี่ยวกับและข้อจำกัดความรับผิด",
  "help.about": "Gia คือผู้ช่วย AI สำหรับผู้ประกอบการเพาะเลี้ยงสัตว์น้ำ พร้อมเครื่องคำนวณทางวิศวกรรมในตัว ตอบจากเอกสารอ้างอิงและความรู้ทั่วไป เพื่อช่วยคุณคิดเรื่องระบบ คุณภาพน้ำ และอุปกรณ์",
  "legal.englishGoverning": "ข้อกำหนดและข้อจำกัดความรับผิดจัดทำเป็นภาษาอังกฤษ และให้ยึดฉบับภาษาอังกฤษเป็นหลัก",
  "feature.notNow": "ไว้ก่อน",
  "feature.seePlans": "ดูแพ็กเกจ",
  "lang.title": "ภาษา",
  "lang.sub": "กำหนดภาษาของหน้าจอและภาษาที่ Gia ใช้ตอบ ไม่ว่าคุณจะพิมพ์ด้วยภาษาใด",
  "lang.auto": "อัตโนมัติ (ตามเบราว์เซอร์และคำถามของฉัน)",
  "pe.timeline.ASAP": "เร็วที่สุด",
  "pe.timeline.1–3 months": "1–3 เดือน",
  "pe.timeline.Just researching": "แค่หาข้อมูล",
  "pe.condition.New": "ของใหม่",
  "pe.condition.Used": "มือสอง",
  "pe.condition.Either": "อย่างไหนก็ได้",
  "pe.missing.quantity": "ต้องการกี่ชุด",
  "pe.missing.city": "ส่งไปที่ไหน",
  "pe.missing.date": "ต้องการเมื่อไร",
  "pe.nudge": "ผู้ขายมักเสนอราคาไม่ได้ถ้ายังไม่ทราบ{list} คุณจะส่งเลยก็ได้",
  "pe.err.name": "กรุณากรอกชื่อของคุณ เพื่อให้เราทราบว่าจะตอบกลับใคร",
  "pe.err.email": "กรุณากรอกอีเมลของคุณ เพื่อให้เราตอบกลับได้",
  "pe.err.emailInvalid": "อีเมลนี้ดูไม่ถูกต้อง กรุณาตรวจสอบ",
  "pe.err.quantity": "กรุณาระบุจำนวนที่ต้องการ",
  "pe.err.city": "กรุณาระบุเมืองที่จัดส่ง",
  "pe.err.send": "ส่งคำขอของคุณไม่สำเร็จ กรุณาลองอีกครั้ง",
  "pe.err.network": "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่",
  "pe.title": "ช่วยหาอุปกรณ์นี้ให้หน่อย",
  "pe.thanks": "ขอบคุณครับ เราจะติดต่อกลับที่ {email}",
  "pe.done": "เสร็จแล้ว",
  "pe.whatYouNeed": "สิ่งที่คุณต้องการ",
  "pe.equipment": "อุปกรณ์",
  "pe.suggestedModels": "รุ่นที่แนะนำ:",
  "pe.hideDetails": "ซ่อนรายละเอียด",
  "pe.editDetails": "แก้ไขรายละเอียด",
  "pe.item": "อุปกรณ์ที่คุณต้องการ",
  "pe.specs": "รายละเอียดและขนาด",
  "pe.name": "ชื่อของคุณ",
  "pe.email": "อีเมล (เพื่อให้เราตอบกลับ)",
  "pe.when": "คุณต้องการเมื่อไร?",
  "pe.quantity": "ต้องการกี่ชุด?",
  "pe.quantityPlaceholder": "เช่น 2 ชุด",
  "pe.city": "เมืองที่จัดส่ง",
  "pe.cityPlaceholder": "จัดส่งไปที่ไหน?",
  "pe.neededBy": "ต้องการภายในวันที่ (ไม่บังคับ)",
  "pe.condition": "ของใหม่หรือมือสอง? (ไม่บังคับ)",
  "pe.budget": "งบประมาณคร่าว ๆ (ไม่บังคับ)",
  "pe.amount": "จำนวนเงิน",
  "pe.budgetAmount": "งบประมาณ",
  "pe.budgetCurrency": "สกุลเงินของงบประมาณ",
  "pe.notSure": "ยังไม่แน่ใจ",
  "pe.note": "มีอย่างอื่นอีกไหม? (ไม่บังคับ)",
  "pe.notePlaceholder": "ข้อมูลอื่นที่ช่วยให้เราหาของได้ตรงความต้องการ",
  "pe.hideFarm": "ซ่อนข้อมูลฟาร์ม",
  "pe.addFarm": "เพิ่มข้อมูลฟาร์ม (ไม่บังคับ)",
  "pe.farm": "ชื่อฟาร์มหรือบริษัท",
  "pe.country": "ประเทศ",
  "pe.sending": "กำลังส่ง…",
  "pe.send": "ส่งคำขอ",
  "pe.reassurance": "ไม่มีข้อผูกมัด เจ้าหน้าที่ของ AquaNetica จะตอบกลับทางอีเมล",
  "toolbar.answerLanguage": "ภาษา: {name}",
  "toolbar.answerLanguageTitle": "ภาษา",
  "project.namePrompt": "ชื่อโปรเจกต์?",
  "project.renamePrompt": "เปลี่ยนชื่อโปรเจกต์:",
  "project.deleteWithChats": "ลบโปรเจกต์ \"{name}\" พร้อมแชท {count} รายการหรือไม่?",
  "project.deleteWithChats_other": "ลบโปรเจกต์ \"{name}\" พร้อมแชท {count} รายการหรือไม่?",
  "project.delete": "ลบโปรเจกต์ \"{name}\" หรือไม่?",
  "file.proTitle": "ข้อความแนบไฟล์เป็นฟีเจอร์ของ Pro",
  "file.proMessage": "แพ็กเกจของคุณไม่รวมข้อความแนบไฟล์ อัปเกรดเป็น Pro เพื่อแนบสเปกชีต แบบแปลน และรูปถ่ายให้ Gia อ่านได้ ข้อความแนบไฟล์คือข้อความใดก็ตามที่คุณส่งขณะมีไฟล์แนบอยู่",
  "file.badType": "กรุณาแนบรูป (JPG, PNG, GIF, WEBP) ไฟล์ PDF ไฟล์ Word, Excel, PowerPoint (.docx, .xlsx, .pptx) หรือไฟล์ข้อความหรือโค้ด (.txt, .md, .csv, .json, .r, .py)",
  "file.tooLarge": "ไฟล์ใหญ่เกินไป ไฟล์แนบต้องไม่เกิน 20 MB",
  "file.unreadable": "Gia อ่านไฟล์นี้ไม่ได้ หากไฟล์มีรหัสผ่าน หรือเป็นไฟล์ .doc, .xls, .ppt แบบเก่า ให้บันทึกเป็น .docx, .xlsx หรือ .pptx โดยไม่ใส่รหัสผ่าน แล้วแนบใหม่อีกครั้ง",
  "file.noText": "ไฟล์นี้ไม่มีข้อความที่ Gia อ่านได้ หากเป็นไฟล์สแกนหรือมีแต่รูปภาพ ให้แนบเป็น PDF หรือรูปภาพแทน",
  "file.tooBig": "ไฟล์นี้ใหญ่เกินกว่าที่ Gia จะอ่านได้ในครั้งเดียว ลองแบ่งเป็นไฟล์เล็กลง หรือแนบเฉพาะส่วนที่ต้องการ",
  "file.notText": "ไฟล์นี้ไม่ใช่ไฟล์ข้อความธรรมดา แม้ชื่อไฟล์จะระบุเช่นนั้น ให้บันทึกเป็นข้อความ (UTF-8) แล้วแนบใหม่อีกครั้ง",
  "chat.errSomething": "ขออภัย เกิดข้อผิดพลาด: {detail}",
  "chat.errNoBackend": "ขออภัย เชื่อมต่อคลังความรู้ไม่ได้ กรุณาตรวจสอบว่าแบ็กเอนด์ทำงานอยู่ที่พอร์ต 3001",
  "file.attached": "· แนบไว้ในแชทนี้",
  "file.left": "เหลือข้อความแนบไฟล์ {count} ข้อความในเดือนนี้",
  "file.left_other": "เหลือข้อความแนบไฟล์ {count} ข้อความในเดือนนี้",
  "file.detachTitle": "เอาไฟล์ออก: จะไม่นับเป็นข้อความแนบไฟล์อีก",
  "file.detachLabel": "เอาไฟล์ออก",
  "file.detach": "เอาออก",
  "file.explain": "ทุกข้อความที่คุณส่งขณะไฟล์นี้แนบอยู่จะนับเป็นข้อความแนบไฟล์หนึ่งข้อความ เอาไฟล์ออกเมื่อ Gia ไม่ต้องใช้อ้างอิงแล้ว",
  "file.reattachHint": "{name}: แนบอีกครั้งเพื่อถามเรื่องไฟล์นี้ต่อ",
  "file.reattachTitle": "แนบไฟล์อีกครั้ง",
  "file.reattach": "แนบอีกครั้ง",
  "usage.questions": "เหลือ {left} จาก {limit} คำถามในเดือนนี้",
  "usage.questions_other": "เหลือ {left} จาก {limit} คำถามในเดือนนี้",
  "usage.questionsShort": "เหลือ {left}/{limit} คำถาม",
  "usage.questionsShort_other": "เหลือ {left}/{limit} คำถาม",
  "usage.files": "เหลือ {left} จาก {limit} ข้อความแนบไฟล์",
  "usage.files_other": "เหลือ {left} จาก {limit} ข้อความแนบไฟล์",
  "usage.leftShort": "เหลือ {left} คำถาม",
  "usage.leftShort_other": "เหลือ {left} คำถาม",
  "usage.remaining": "เหลือ {left} / {limit} คำถาม",
  "usage.remaining_other": "เหลือ {left} / {limit} คำถาม",
  "usage.upgrade": "อัปเกรด",
  "wall.daily": "คุณใช้ข้อความครบตามขีดจำกัดของวันนี้แล้ว",
  "wall.feature": "แพ็กเกจ {plan} ไม่รวมฟีเจอร์นี้",
  "wall.featureYour": "แพ็กเกจของคุณไม่รวมฟีเจอร์นี้",
  "wall.files": "คุณใช้ข้อความแนบไฟล์ครบ {limit} ข้อความของแพ็กเกจ {plan} ในเดือนนี้แล้ว",
  "wall.questions": "คุณใช้คำถามครบ {limit} คำถามของแพ็กเกจ {plan} ในเดือนนี้แล้ว",
  "wall.generic": "คุณใช้ครบขีดจำกัดของแพ็กเกจแล้ว",
  "wall.region": "ใช้คำถามครบแล้ว",
  "wall.refresh": "คำถามของแพ็กเกจ {plan} จะรีเซ็ตทุกวันที่ 1",
  "wall.refreshNoPlan": "คำถามของคุณจะรีเซ็ตทุกวันที่ 1",
  "wall.stayFree": "เครื่องคำนวณยังใช้ได้ฟรีไม่จำกัด และแชทเก่าทั้งหมดยังอยู่ให้อ่านได้",
  "wall.upgrade": "อัปเกรดที่ aquanetica.com",
  "sidebar.hide": "ซ่อนแถบด้านข้าง",
  "sidebar.search": "ค้นหาแชท…",
  "sidebar.newChat": "+ แชทใหม่",
  "sidebar.newProject": "+ โปรเจกต์",
  "sidebar.tools": "🛠️ เครื่องมือ",
  "sidebar.backToGia": "กลับไปหา Gia",
  "sidebar.calculator": "เครื่องคำนวณ",
  "sidebar.empty": "ยังไม่มีแชท ถาม Gia อะไรก็ได้เพื่อเริ่มต้น",
  "sidebar.profileSet": "ตั้งค่าข้อมูลระบบแล้ว",
  "sidebar.newInProject": "แชทใหม่ในโปรเจกต์นี้",
  "sidebar.editProfile": "แก้ไขข้อมูลระบบ",
  "sidebar.rename": "เปลี่ยนชื่อ",
  "sidebar.delete": "ลบ",
  "sidebar.projectEmpty": "ยังไม่มีแชท",
  "sidebar.noMatches": "ไม่พบผลลัพธ์สำหรับ \"{q}\"",
  "sidebar.signedIn": "เข้าสู่ระบบแล้ว",
  "sidebar.signOut": "ออกจากระบบ",
  "sidebar.signingOut": "กำลังออกจากระบบ…",
  "signout.title": "ออกจากระบบ",
  "signout.body": "คุณจะออกจากระบบ AquaNetica IQ และ aquanetica.com เอกสารที่อัปโหลดและการให้คะแนนคำตอบจะถูกลบจากอุปกรณ์นี้เสมอ สิ่งอื่นที่คุณบันทึกไว้จะยังอยู่เมื่อคุณกลับมาเข้าสู่ระบบ",
  "signout.alsoClear": "ลบงานที่บันทึกไว้ในอุปกรณ์นี้ด้วย ได้แก่ บทสนทนา โครงการ และการคำนวณ",
  "signout.irreversible": "การลบเพิ่มเติมนี้ถาวร งานเหล่านั้นเก็บไว้ในเบราว์เซอร์นี้เท่านั้น จึงไม่มีสำเนาสำรองให้กู้คืน",
  "signout.confirm": "ออกจากระบบ",
  "sidebar.communityTitle": "กลับไปที่ชุมชน AquaNetica (เปิดในแท็บใหม่)",
  "sidebar.community": "กลับไปที่ AquaNetica",
  "sidebar.help": "ความช่วยเหลือและข้อจำกัดความรับผิด",
  "drop.label": "วางไฟล์เพื่อแนบ",
  "toolbar.showSidebar": "แสดงแถบด้านข้าง",
  "toolbar.toggleSidebar": "แสดงหรือซ่อนแถบด้านข้าง",
  "toolbar.newChat": "แชทใหม่",
  "toolbar.inProject": "ในโปรเจกต์:",
  "toolbar.home": "กลับไปที่ชุมชน AquaNetica",
  "toolbar.homeTitle": "กลับไปที่ AquaNetica (เปิดในแท็บใหม่)",
  "toolbar.calc": "เปิดเครื่องคำนวณ",
  "toolbar.theme": "สลับธีมสว่าง/มืด",
  "hero.title": "ให้ช่วยอะไรดี?",
  "hero.calibrated": "Gia ปรับตามข้อมูลระบบของโปรเจกต์นี้แล้ว",
  "hero.noProfile": "ยังไม่มีข้อมูลระบบ กดที่ ⚙ บนโปรเจกต์เพื่อกรอก",
  "hero.subtitle": "ถามได้ทุกเรื่องเกี่ยวกับระบบเพาะเลี้ยงสัตว์น้ำ คุณภาพน้ำ หรืออุปกรณ์",
  "composer.attachTitle": "แนบรูปภาพหรือ PDF",
  "composer.attachLabel": "แนบไฟล์",
  "composer.send": "ส่ง",
  "answer.copyTitle": "คัดลอกคำตอบ",
  "answer.copied": "คัดลอกแล้ว",
  "answer.copy": "คัดลอก",
  "answer.retryTitle": "ถามคำถามนี้อีกครั้ง",
  "answer.retryLabel": "ขอคำตอบใหม่",
  "answer.retry": "ลองใหม่",
  "answer.good": "คำตอบดี",
  "answer.bad": "คำตอบไม่ดี",
  "answer.sourcing": "ต้องการให้ช่วยหาอุปกรณ์นี้ไหม? →",
  "answer.searching": "กำลังค้นคลังเอกสาร…",
  "answer.scrollLatest": "ไปที่ล่าสุด",
  "sidebar.otherChats": "อื่น ๆ",
  "trial.have": "มีโค้ดไหม?",
  "trial.title": "โค้ดทดลองใช้",
  "trial.placeholder": "กรอกโค้ดทดลองใช้ของคุณ",
  "trial.submit": "ใช้โค้ด",
  "trial.checking": "กำลังตรวจสอบ…",
  "trial.invalid": "โค้ดนี้ใช้ไม่ได้ กรุณาตรวจสอบแล้วลองใหม่",
  "trial.error": "ตรวจสอบโค้ดนี้ไม่ได้ กรุณาลองใหม่",
  "trial.success": "เริ่มทดลองใช้ Pro แล้ว คุณมี 75 คำถามและ 10 ข้อความแนบไฟล์ต่อเดือน จนถึง {date}",
  "trial.active": "ทดลองใช้ Pro ถึง {date}",
  "sidebar.planTrial": "ทดลองใช้ {plan}",
  "sidebar.managePlan": "จัดการแพ็กเกจ",
  "trial.ends": "ทดลองใช้สิ้นสุด {date}",
  "pe.consent": "ข้าพเจ้ายินยอมให้แบ่งปันรายละเอียดคำขอของข้าพเจ้ากับ AquaNetica และกับผู้ขายที่ติดต่อในนามของข้าพเจ้า และยอมรับ{terms}และ{privacy}",
  "pe.consentTerms": "ข้อกำหนดในการให้บริการ",
  "pe.consentPrivacy": "นโยบายความเป็นส่วนตัว",
};

export default strings;
